<template>
  <div class="container py-4 col-12 col-lg-10" id="container">

    <!-- BREADCRUMB -->
    <!-- <nav class="mb-3 mb-md-5" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="/"><b>Início</b></a></li>
        <li class="breadcrumb-item active" aria-current="page">Alterar senha</li>
      </ol>
    </nav> -->

    <!-- TÍTULO -->
    <div class="row mb-md-5 page-header">
      <div class="col-12">
        <p class="page-header-eyebrow">SEGURANÇA</p>
        <h1 class="page-title mb-1">Alterar senha</h1>
        <p class="page-subtitle mb-0">Altere sua senha abaixo.</p>
      </div>
    </div>

    <div class="row">
      
      <div class="perfil-card col-12 mx-auto">

        <!-- HEADER -->
        <div class="perfil-header mb-5" v-if="usuarioLogado">
          <div class="avatar-wrapper">
            <div class="avatar">{{ iniciaisUsuario }}</div>
          </div>

          <div class="text-center mt-2">
            <b>{{ usuarioLogado.nome }}</b>
            <div class="text-muted small">{{ usuarioLogado.email }}</div>
          </div>
        </div>

        <!-- FORM -->
        <form @submit.prevent="alterarSenha">

          <h5 class="titulo-sessao mb-3">Informações de segurança</h5>

          <!-- SENHA ATUAL -->
          <label class="form-label">Senha atual</label>
          <div class="campo-senha mb-3">

            <img
              src="../img/block-blue-icon.svg"
              class="icone cadeado"
              alt="Senha"
            />

            <input
              :type="mostrarSenhaAtual ? 'text' : 'password'"
              class="form-control input-senha"
              v-model="senhaAtual"
              placeholder="Digite sua senha atual"
              required
            />

            <img
              src="../img/eye-icon.svg"
              class="icone olho"
              alt="Mostrar senha"
              @click="mostrarSenhaAtual = !mostrarSenhaAtual"
            />
          </div>

          <!-- NOVA SENHA -->
          <label class="form-label">Nova senha</label>
          <div class="campo-senha mb-3">

            <img
              src="../img/block-blue-icon.svg"
              class="icone cadeado"
              alt="Senha"
            />

            <input
              :type="mostrarNovaSenha ? 'text' : 'password'"
              class="form-control input-senha"
              v-model="novaSenha"
              placeholder="Digite sua nova senha"
              required
            />

            <img
              src="../img/eye-icon.svg"
              class="icone olho"
              alt="Mostrar senha"
              @click="mostrarNovaSenha = !mostrarNovaSenha"
            />
          </div>

          <!-- CONFIRMAR SENHA -->
          <label class="form-label">Confirmar nova senha</label>
          <div class="campo-senha mb-4">

            <img
              src="../img/block-blue-icon.svg"
              class="icone cadeado"
              alt="Senha"
            />

            <input
              :type="mostrarConfirmarSenha ? 'text' : 'password'"
              class="form-control input-senha"
              v-model="confirmarNovaSenha"
              placeholder="Confirme sua nova senha"
              required
            />

            <img
              src="../img/eye-icon.svg"
              class="icone olho"
              alt="Mostrar senha"
              @click="mostrarConfirmarSenha = !mostrarConfirmarSenha"
            />
          </div>

          <button type="submit" class="btn btn-primary botao-azul w-100">
            Salvar alterações
          </button>

        </form>
      </div>
    </div>

  </div>

  <AlertModal
    :visible="alertModal.visible"
    :title="alertModal.title"
    :message="alertModal.message"
    :type="alertModal.type"
    @close="fecharAlert"
  />

  <LoadingModal
    :visible="loading.visible"
    :title="loading.title"
    :message="loading.message"
  />
</template>

<script>
import AlertModal from '@/componentesTelas/AlertModal.vue';
import LoadingModal from '@/componentesTelas/LoadingModal.vue';
import { getUsuario, setUsuario } from '@/utils/authStorage';

export default {
  name: "AlterarSenha",
  components: {
    AlertModal,
    LoadingModal
  },
  data() {
    return {
      senhaAtual: "",
      novaSenha: "",
      confirmarNovaSenha: "",
      usuarioLogado: null,

      mostrarSenhaAtual: false,
      mostrarNovaSenha: false,
      mostrarConfirmarSenha: false,

      alertModal: {
        visible: false,
        title: '',
        message: '',
        type: 'info',
        recarregarAoFechar: false
      },

      loading: {
        visible: true,
        title: 'Carregando dados',
        message: 'Aguarde um momento...'
      }
    };
  },
  computed: {

    iniciaisUsuario() {
      if (!this.usuarioLogado?.nome) return "";
      return this.usuarioLogado.nome
        .split(" ")
        .map(p => p[0])
        .join("")
        .substring(0, 2)
        .toUpperCase();
    }
  },
  mounted() {

    this.usuarioLogado = getUsuario();
    this.ajustarTamanhoCardPrincipal();
    this.loadingTimer = window.setTimeout(() => {
      this.loading.visible = false;
    }, 500);

  },
  beforeUnmount() {
    if (this.loadingTimer) {
      window.clearTimeout(this.loadingTimer);
    }
  },
  methods: {

    abrirAlert(title, message, type = 'info', recarregarAoFechar = false) {
      this.alertModal = {
        visible: true,
        title,
        message,
        type,
        recarregarAoFechar
      };
    },

    fecharAlert() {
      const recarregarAoFechar = this.alertModal.recarregarAoFechar;
      this.alertModal.visible = false;

      if (recarregarAoFechar) {
        location.reload();
      }
    },

    ajustarTamanhoCardPrincipal() {
      const card = document.querySelector(".card-principal");
      if (card) {
        card.style.maxWidth = "800px";
      }
    },

    async alterarSenha() {

      if (this.novaSenha !== this.confirmarNovaSenha) {
        this.abrirAlert("Sistema", "A nova senha e a confirmação são diferentes.", "error");
        return;
      }

      if (this.senhaAtual.length < 8 || this.novaSenha.length < 8) {
        this.abrirAlert("Sistema", "A senha deve ter pelo menos 8 caracteres.", "error");
        return;
      }

      try {
        const response = await fetch(
          `${process.env.VUE_APP_BACKEND_URL}/alterar-senha`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              email: this.usuarioLogado.email,
              senhaAtual: this.senhaAtual,
              novaSenha: this.novaSenha
            })
          }
        );

        if (response.ok) {
          setUsuario(this.usuarioLogado);
          this.abrirAlert("Sistema", "Senha atualizada.", "success", true);
        } else if (response.status === 422) {
          this.abrirAlert("Sistema", "A senha atual está incorreta.", "error");
        } else {
          this.abrirAlert("Sistema", "Erro ao alterar senha.", "error");
        }

      } catch (err) {
        console.error(err);
        this.abrirAlert("Sistema", "Erro ao alterar senha. Tente novamente mais tarde.", "error");
      }
    }
  }
};
</script>

<style>
.perfil-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin: 28px 0 24px;
}

.avatar-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.avatar {
  width: 64px;
  height: 64px;
  aspect-ratio: 1 / 1;
  background-color: #EDF7FF;
  color: #0056FF;
  border-radius: 50%;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
}

/* Wrapper do campo */
.campo-senha {
  position: relative;
}

/* Ícones */
.icone {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  opacity: 0.6;
  z-index: 2;
}

.icone:hover {
  opacity: 1;
  cursor: pointer;
}

/* Cadeado à esquerda */
.cadeado {
  left: 12px;
}

/* Olho à direita */
.olho {
  right: 12px;
}

/* Espaço real no input */
.input-senha {
  padding-left: 44px;
  padding-right: 44px;
}

/* RESPONSIVIDADE MOBILE */
@media (max-width: 768px) {

  .perfil-card {
    border: none;
  }

}

</style>
